import React from "react";
import { useLocation } from "react-router-dom";

function PageNotFound() {
  const location = useLocation();
  return (
    <div
      className="text-white flex j-c-center a-i-center"
      style={{ height: "calc(100vh - 246px)" }}
    >
      <h2>{location?.state?.message ?? "Ticket Not Found."}</h2>
    </div>
  );
}

export default PageNotFound;
